import React, { useEffect, useState } from 'react';
import ComplementoConceptoList from './ComplementoConceptoList';
import HidroYPetroCatalogoManager from '../../../catalogs/managers/HidroYPetroCatalogoManager';

const ComplementoConcepto = (props) => {
  const { data } = props;
  const [bootCatalog, setBootCatalog] = useState(false);

  useEffect(() => {
    const bootCatalogs = async () => {
      await HidroYPetroCatalogoManager.boot();

      setBootCatalog(true);
    };

    bootCatalogs();
  }, [bootCatalog]);

  const { Complemento, ComplementoConcepto = {} } = data;

  let input = null;
  let Component = null;

  if (Complemento) {
    Component = ComplementoConceptoList[Complemento];

    input = ComplementoConcepto[Complemento] || {};
  }

  const handleOnChange = (complemento, event) => {
    const data = {
      ...props.data,
      [`isValid_${complemento}`]: event.isValid,
      ComplementoConcepto: {
        [complemento]: {
          ...event.data,
        },
      },
    };

    props.onChange({ data });
  };

  const handleOnCancel = (complemento) => {
    const _complemento = props.data?.Complemento;

    props.onCancel({
      ...data,
      Complemento: _complemento === complemento ? undefined : _complemento,
      [`isValid_${complemento}`]: false,
      ComplementoConcepto: {
        [complemento]: undefined,
      },
    });
  };

  return (
    <div>
      {!!Component && (
        <Component
          data={input}
          onChange={handleOnChange}
          onCancel={handleOnCancel}
        />
      )}
    </div>
  );
};

export default ComplementoConcepto;
